var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKebab = function SvgKebab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 26a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#fff"
  })));
};

export { SvgKebab as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDEwQzE3LjEwNDYgMTAgMTggOS4xMDQ1NyAxOCA4QzE4IDYuODk1NDMgMTcuMTA0NiA2IDE2IDZDMTQuODk1NCA2IDE0IDYuODk1NDMgMTQgOEMxNCA5LjEwNDU3IDE0Ljg5NTQgMTAgMTYgMTBaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTYgMThDMTcuMTA0NiAxOCAxOCAxNy4xMDQ2IDE4IDE2QzE4IDE0Ljg5NTQgMTcuMTA0NiAxNCAxNiAxNEMxNC44OTU0IDE0IDE0IDE0Ljg5NTQgMTQgMTZDMTQgMTcuMTA0NiAxNC44OTU0IDE4IDE2IDE4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE2IDI2QzE3LjEwNDYgMjYgMTggMjUuMTA0NiAxOCAyNEMxOCAyMi44OTU0IDE3LjEwNDYgMjIgMTYgMjJDMTQuODk1NCAyMiAxNCAyMi44OTU0IDE0IDI0QzE0IDI1LjEwNDYgMTQuODk1NCAyNiAxNiAyNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";